import styled from "@emotion/styled";

export const CustomEdgeContainer = styled("div")<{
  labelX: number;
  labelY: number;
}>((theme) => ({
  position: "absolute",
  transform: `translate(-50%, -50%) translate(${theme.labelX}px,${theme.labelY}px)`,
  background: "#aa97f7",
  padding: 7,
  borderRadius: 5,
  fontSize: 12,
  fontWeight: 700
}));

export const CustomNodeContainer = styled("div")({
  border: "1px solid #777",
  padding: 10,
  height: "100px",
  width: "200px",
  display: "flex",
  textAlign: "center",
  alignItems: "center",
  justifyContent: "center",
});

export const StyledNodeLabel = styled("strong")({
  overflow: "hidden",
  wordBreak: "break-word",
});

export const StyledEdgePopupContainer = styled("div")({
  position: "fixed",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  backgroundColor: "#fff",
  border: "1px solid #ccc",
  padding: "20px",
  zIndex: 1000,
  boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
  maxWidth: "400px",
  width: "100%",
});

export const StyledEdgeContainer = styled("div")({
  padding: "5px",
  textWrap: "wrap",
  display: "flex",
  flexDirection: "column",
  justifyContent: "spaceAround",
  maxHeight: "500px",
  fontSize: "16px",
  gap: "10px"
});

export const SpaceWrapper = styled("div")({
  margin: "10px",
  width: "100%",
});

export const StyledEdgeTitle = styled("div")({
  fontWeight: 600,
  textAlign: "center",
});

export const FlowBuilderContainer = styled("div")({
  height: "100%",
  position: "relative",
});

export const StyledEdgeContent = styled("div")({
  display: "flex",
  alignItems: "flex-start",
  flexDirection: "column",
  gap: "5px",
});

export const StyledEdgeDropdownContainer = styled("div")({
  display: "flex",
  alignItems: "flex-start",
  flexDirection: "column",
  gap: "15px",
  marginBottom: "20px"
});

export const StyledCondition = styled("div")({
  fontWeight: 600,
});

export const ErrorMessageContainer = styled("div")({
  width: "calc(100% - 10px)",
  height: "100%",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  fontSize: "14px",
  fontFamily: "Poppins",
  padding: "5px",
  backgroundColor: "#ea8a8a8c",
});

export const LogicButtonContainer = styled("div")({
  display: "flex",
  justifyContent: "space-around"
})
